<div
  *transloco="let t; read: 'widgets.add-to-widget-group-dialog'"
  class="xi-modal__container add-to-dfg__container"
>
  <h2 class="xi-modal__title kxi-text-center">{{ t('add-to-widget-group') }}</h2>

  <form [formGroup]="addDFGForm" (ngSubmit)="onAddToDFG()">
    <div class="xi-modal__content add-to-dfg__content">
      <div class="add-to-dfg__dropdown">
        <xi-dropdown
          formControlName="filterGroup"
          [label]="t('widget-group')"
          [placeholder]="t('select-widget-group')"
          name="filterGroup"
          [stretch]="true"
          [data]="widgetGroups"
        ></xi-dropdown>
      </div>

      <div class="add-to-dfg__dropdown">
        <xi-dropdown
          formControlName="filterType"
          [label]="t('filter-type')"
          name="filterType"
          [stretch]="true"
          [data]="docFilterTypeData"
        ></xi-dropdown>
      </div>
    </div>

    <div class="xi-modal__actions">
      <xi-default-button
        type="button"
        [text]="t('cancel')"
        fill="text"
        (onClick)="onCancel()"
      ></xi-default-button>

      <xi-default-button
        [text]="t('save')"
        [disabled]="!isValid"
        (onClick)="onSave()"
      ></xi-default-button>
    </div>
  </form>
</div>
